var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { ENTER_KEY } from '#constants';
import { Label } from '../../../Label';
import { Typography } from '../../../Typography';
import { useMenu } from '../../context';
import { MenuTestIdFactory } from '../../interactions';
import { useMenuItem } from '../ArrowNavigationMenu';
import { classNameMap } from './classNameMap';
import styles from './MenuItem.module.css';
const MenuItemContainer = ({ children, 'data-testid': testid, disabled = false, hidden = false, isActive, kind = 'standard', onClick, state, target, to, }) => {
    _react_refresh_temp_3();
    const disabledProps = disabled
        ? { tabIndex: -1, 'aria-disabled': true }
        : { tabIndex: 0 };
    const menuItemRef = useRef(null);
    useMenuItem({ menuItemRef, hidden, disabled });
    useMenu({ isActive, menuItemRef });
    const navigate = useNavigate();
    if (hidden) {
        return null;
    }
    const onButtonClick = (event) => {
        event.preventDefault();
        if (disabled) {
            return event.stopPropagation();
        }
        if (onClick) {
            onClick();
        }
    };
    return (_jsx("li", { className: styles.ListItem, role: "none", children: to ? (_jsx(NavLink, { ref: menuItemRef, ...disabledProps, className: ({ isActive: navIsActive }) => classNameMap({
                disabled: disabled || false,
                kind,
                isActive: isActive ?? navIsActive,
            }), "data-active": isActive ?? undefined, "data-testid": MenuTestIdFactory.getMenuItemTestId(testid), onClick: (event) => {
                if (disabled) {
                    event.preventDefault();
                }
                else {
                    if (onClick) {
                        onClick();
                    }
                }
            }, onKeyDown: (e) => {
                if (e.key === ENTER_KEY) {
                    void navigate(to, { state });
                }
            }, role: "menuitem", state: state, target: target, to: to, children: children })) : (_jsx("button", { className: classNameMap({
                disabled: disabled || false,
                kind,
            }), "data-testid": MenuTestIdFactory.getMenuItemTestId(testid), disabled: disabled, onClick: onButtonClick, 
            // We need this, because otherwise if the parent has a
            // keydown event that closes it, we lose the functionality
            // of onClick on "Enter" keydown
            onKeyDown: (event) => {
                if (event.key !== ENTER_KEY) {
                    return;
                }
                onButtonClick(event);
            }, ref: menuItemRef, role: "menuitem", type: "button", children: children })) }));
};
_react_refresh_temp_1 = MenuItemContainer;
$RefreshReg$(_react_refresh_temp_1, "MenuItemContainer");
_react_refresh_temp_3(MenuItemContainer, "/o5UgPhl3fglqd+uq1b2XP/Z8QY=", false, () => [useMenuItem, useMenu, useNavigate]);
export const MenuItem = ({ 'data-testid': testid, disabled = false, hidden = false, isActive, kind = 'standard', labelProps, LeadingIcon, onClick = () => { }, state, target, text, to, TrailingIcon, }) => {
    return (_jsxs(MenuItemContainer, { "data-testid": testid, disabled: disabled, hidden: hidden, isActive: isActive, kind: kind, onClick: onClick, ...(to !== undefined && { to, state, target }), children: [_jsxs("span", { className: styles.Leading, children: [LeadingIcon && _jsx(LeadingIcon, { size: "small" }), _jsx(Typography, { className: styles.Text, color: "inherit", "data-testid": MenuTestIdFactory.getMenuItemTextTestId(testid), fontWeight: "medium", kind: "generic-small", children: text })] }), _jsxs("span", { className: styles.Trailing, children: [labelProps && (_jsx(Label, { color: labelProps.color, "data-testid": MenuTestIdFactory.getMenuItemTestId(testid), size: "small", text: labelProps.text })), TrailingIcon && _jsx(TrailingIcon, { size: "small" })] })] }));
};
_react_refresh_temp_2 = MenuItem;
$RefreshReg$(_react_refresh_temp_2, "MenuItem");
